// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LineHeightOutlinedSvg from "@fishx/icons-svg/es/asn/LineHeightOutlined";
import FishxIcon from '../components/FishxIcon';

var LineHeightOutlined = function LineHeightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LineHeightOutlinedSvg
  }));
};

LineHeightOutlined.displayName = 'LineHeightOutlined';
export default React.forwardRef(LineHeightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LineHeightOutlined.js
// module id = 3041
// module chunks = 0